// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { PositionInfo } from '@shared/commons/cache/PositionInfo';
import { PositionInfoItem } from '@shared/commons/cache/PositionInfoItem';
import { PositionInfoType } from '@shared/commons/cache/PositionInfoType';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { InstrumentSpecificType } from '@shared/utils/Instruments/InstrumentSpecificType';
import { TradingPositionType } from '@shared/utils/Instruments/TradingPositionType';
import InstrumentTotalInfoTemplate from '@front/templates/InstrumentTotalInfoTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { Control } from './Control';
export class InstrumentTotalInfo extends Control {
    constructor() {
        super(...arguments);
        this.InstrumentForData = null;
        this.PositionInfo = new PositionInfo();
        this.infoItems = {};
    }
    getType() {
        return ControlsTypes.InstrumentTotalInfo;
    }
    oninit() {
        super.oninit();
        Control.Ticker.Subscribe(this.TickAsync, this);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
        this.observe('instrument', this.CorrectingSourceObject);
        this.setDefaultInfoItems();
    }
    dispose() {
        Control.Ticker.UnSubscribe(this.TickAsync, this);
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    // TODO fucking shit
    CorrectingSourceObject(newInstrument, _oldInstrument) {
        var _a;
        if (!isNullOrUndefined(newInstrument)) {
            if (newInstrument.InstrumentSpecificType !== InstrumentSpecificType.ContinuousContract &&
                newInstrument.isFuturesSymbol) {
                const x = DataCache.getInstrumentByTradable_ID(newInstrument.InstrumentTradableID, newInstrument.Route);
                if (!isNullOrUndefined(x) &&
                    x.InstrumentSpecificType === InstrumentSpecificType.ContinuousContract &&
                    x.isFuturesSymbol) {
                    this.InstrumentForData = x;
                }
                else {
                    this.InstrumentForData = newInstrument;
                }
            }
            else {
                this.InstrumentForData = newInstrument;
            }
        }
        const isHedging = ((_a = this.InstrumentForData) === null || _a === void 0 ? void 0 : _a.TradingPositionType) === TradingPositionType.MultiPosition;
        void this.set({ isHedging });
    }
    TickAsync() {
        var _a;
        const instrument = this.InstrumentForData;
        const account = this.get('account');
        if (isNullOrUndefined(instrument) || isNullOrUndefined(account)) {
            return;
        }
        this.PositionInfo.Recalculate(instrument, account);
        for (const key in this.infoItems) {
            (_a = this.infoItems[key]) === null || _a === void 0 ? void 0 : _a.Update();
        }
        void this.set({ items: this.infoItems });
    }
    localize() {
        void this.set({
            quantityText: Resources.getResource('panel.instrumentInfo.Qty'),
            avgPriceText: Resources.getResource('panel.instrumentInfo.Price'),
            plText: Resources.getResource('panel.instrumentInfo.P/L'),
            breakEvenText: Resources.getResource('panel.instrumentInfo.BEven')
        });
    }
    setDefaultInfoItems() {
        this.infoItems[PositionInfoType.AverageOpenPrice] = new PositionInfoItem(PositionInfoType.AverageOpenPrice, this.PositionInfo);
        this.infoItems[PositionInfoType.BreakEven] = new PositionInfoItem(PositionInfoType.BreakEven, this.PositionInfo);
        this.infoItems[PositionInfoType.NetQTY] = new PositionInfoItem(PositionInfoType.NetQTY, this.PositionInfo);
        this.infoItems[PositionInfoType.LongQty] = new PositionInfoItem(PositionInfoType.LongQty, this.PositionInfo);
        this.infoItems[PositionInfoType.ShortQty] = new PositionInfoItem(PositionInfoType.ShortQty, this.PositionInfo);
        this.infoItems[PositionInfoType.PLByCurrency] = new PositionInfoItem(PositionInfoType.PLByCurrency, this.PositionInfo);
    }
}
Control.extendWith(InstrumentTotalInfo, {
    template: InstrumentTotalInfoTemplate,
    data: function () {
        return {
            account: null,
            instrument: null,
            breakEvenText: '',
            quantityText: '',
            avgPriceText: '',
            plText: '',
            items: {},
            isHedging: false
        };
    }
});
